import auth0 from 'auth0-js';
import jwtDecode from 'jwt-decode';
import api from '../utils/api';
import AUTH_CONFIG from './auth0.json';

let callbackUrl = AUTH_CONFIG.callbackUrl;
if (location) {
    callbackUrl = `${location.origin}/login/callback`;
}

/* eslint-disable no-underscore-dangle */
api.interceptors.response.use(
    response => response,
    (error) => {
        const originalRequest = error.config;

        // if the error is 401 and hasn't already been retried
        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            // mark our retry
            originalRequest._retry = true;

            // if we do a router.push() here, the whole app fails to load?
            // How comes???!!!
            window.location.path = `/login?redirect=${window.location.href}&autologin=true`;
            // reauthenticate
            // router.push({
            //     path: '/login',
            //     query: {
            //         redirect: router.currentRoute.fullPath,
            //         autologin: true,
            //     },
            // });
        }

        // Do something with response error
        return Promise.reject(error);
    },
);


function getItem(key) {
    const item = localStorage.getItem(key);

    if (item === 'undefined') {
        return undefined;
    }

    return item;
}

function setItem(key, value) {
    if (value) {
        localStorage.setItem(key, value);
    } else {
        localStorage.removeItem(key);
    }
}

function removeItem(key) {
    localStorage.removeItem(key);
}


/* eslint-disable no-param-reassign */
const utils = {
    saveLoginInfo(state, data) {
        state.auth = data;

        if (data && data.idToken) {
            state.profile = jwtDecode(data.idToken);
        } else {
            state.profile = undefined;
        }

        api.defaults.headers.common.Authorization = `Bearer ${data.accessToken}`;

        setItem('accessToken', data.accessToken);
        setItem('idToken', data.idToken);
        setItem('expiresAt', JSON.stringify(data.expiresAt));
    },
    clearLoginInfo(state) {
        removeItem('accessToken');
        removeItem('idToken');
        removeItem('expiresAt');

        // clear auth info from state
        state.auth = undefined;
        state.profile = undefined;

        api.defaults.headers.common.Authorization = undefined;
    },
    restoreLoginInfo() {
        if (getItem('accessToken')) {
            // get security info from localstorage
            const accessToken = getItem('accessToken');
            const idToken = getItem('idToken');
            const expiresAt = JSON.parse(getItem('expiresAt'));

            return {
                accessToken,
                idToken,
                expiresAt,
            };
        }

        return undefined;
    },
};

function isAuthenticated() {
    return (getItem('accessToken'))
        && (new Date().getTime() < getItem('expiresAt'));
}

const AUTH = {
    namespaced: true,
    state: {
        auth: undefined,
        auth0: new auth0.WebAuth({
            domain: AUTH_CONFIG.domain,
            clientID: AUTH_CONFIG.clientId,
            redirectUri: callbackUrl,
            audience: AUTH_CONFIG.audience,
            responseType: AUTH_CONFIG.responseType,
            scope: AUTH_CONFIG.scope,
        }),
        profile: undefined,
    },
    getters: {
        authService(state) {
            return state.authService;
        },
        profile(state) {
            return state.profile;
        },
        authHeader(state) {
            if (state.auth) {
                return {
                    Authorization: `Bearer ${state.auth.accessToken}`,
                };
            }

            return undefined;
        },
        // organisationId(state) {
        //     return state.profile ? state.profile.sub : undefined;
        // },
        userId(state) {
            return state.profile ? state.profile.sub : undefined;
        },
    },
    /* eslint-disable no-param-reassign */
    mutations: {
        SAVE_AUTH(state, data) {
            utils.saveLoginInfo(state, data);
        },
        LOGOUT(state) {
            utils.clearLoginInfo(state);
        },
        AUTHORIZE(state, redirect) {
            if (!isAuthenticated()) {
                // save redirect in local storage to revive after return from Auth0
                setItem('redirect', redirect || '/');

                utils.clearLoginInfo(state);
                state.auth0.authorize();
            }
        },
    },
    actions: {
        LOGIN(context) {
            return new Promise((resolve, reject) => {
                context.state.auth0.parseHash((err, authResult) => {
                    if (authResult && authResult.accessToken && authResult.idToken) {
                        context.commit('SAVE_AUTH', {
                            accessToken: authResult.accessToken,
                            idToken: authResult.idToken,
                            expiresAt: (authResult.expiresIn * 1000) + new Date().getTime(),
                        });

                        // revive redirect url from local storage
                        const redirect = getItem('redirect');
                        removeItem('redirect');

                        resolve(redirect);
                    } else if (err) {
                        reject(err);
                    }
                });
            });
        },
        INIT(context) {
            return new Promise((resolve) => {
                const loginInfo = utils.restoreLoginInfo();
                if (loginInfo) {
                    context.commit('SAVE_AUTH', loginInfo);
                }
                resolve(true);
            });
        },
    },
};

export {
    isAuthenticated,
    AUTH as default,
};



// WEBPACK FOOTER //
// ./src/store/auth.js